/**
 * @enum {string}
 * @hidden
 */
export const Permalink3dParam = {
  /**
   * @type {string}
   */
  ENABLED: '3d_enabled',
  /**
   * @type {string}
   */
  LON: '3d_lon',
  /**
   * @type {string}
   */
  LAT: '3d_lat',
  /**
   * @type {string}
   */
  ELEVATION: '3d_elevation',
  /**
   * @type {string}
   */
  HEADING: '3d_heading',
  /**
   * @type {string}
   */
  PITCH: '3d_pitch',
  /**
   * @type {string}
   */
  PREFIX: '3d_'
};
